// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1ZtwW","insightsList":"newBusinessInsightsMenu_insightsList__1YPyE","active":"newBusinessInsightsMenu_active__2bxhN"};